"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAnyLinkDef = exports.fromAnyLink = exports.AnyLinkDef = void 0;
const tslib_1 = require("tslib");
const fp_ts_1 = require("fp-ts");
const function_1 = require("fp-ts/lib/function");
const t = tslib_1.__importStar(require("io-ts"));
const codec = t.partial({
    select: t.union([t.literal("any"), t.null, t.undefined]),
});
exports.AnyLinkDef = new t.Type("AnyLinkDef", (u) => u.select === "any", (u) => {
    return (0, function_1.pipe)(codec.decode(u), fp_ts_1.either.map(() => {
        return {
            select: "any",
        };
    }));
}, (l) => l);
function fromAnyLink(link) {
    var _a;
    if ((_a = link.config) === null || _a === void 0 ? void 0 : _a.select)
        return;
    return {
        select: "any",
    };
}
exports.fromAnyLink = fromAnyLink;
function defaultAnyLinkDef() {
    return {
        select: "any",
    };
}
exports.defaultAnyLinkDef = defaultAnyLinkDef;
